import { render, staticRenderFns } from "./SelectStatusCorporate.vue?vue&type=template&id=2d7c6b7c&"
import script from "./SelectStatusCorporate.vue?vue&type=script&lang=js&"
export * from "./SelectStatusCorporate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports